import * as React from 'react';

import { Link } from '../../../../../common/Link';
import { forbiddenIcon } from '../../icons';
import { ErrorWrapper } from '../ErrorWrapper';

import { DENIED_BY_SANCTIONS_LINK } from './constants';

export const BlockOfferPublication = () => (
  <ErrorWrapper icon={forbiddenIcon}>
    Вы не можете публиковать объявление из-за ограничений от модерации.{' '}
    <Link href={DENIED_BY_SANCTIONS_LINK} target="_blank" rel="noreferrer">
      Подробнее
    </Link>
  </ErrorWrapper>
);
